var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/retake_button.230babcf.png","uri@2x": __webpack_public_path__ + "static/media/retake_button.e822f885.png","uri@3x": __webpack_public_path__ + "static/media/retake_button.3cc12312.png",
    width: 42,
    height: 42
});